<template>
  <div class="min-h-screen flex flex-col">
    <TopHeader class="max-lg:hidden" />
    <div class="container">
      <MallHeader class="max-lg:mt-5" />
      <main class="flex-auto max-md:px-3.75">
        <router-view />
      </main>
      <MallNav></MallNav>
    </div>
    <TheFooter></TheFooter>
  </div>
  <PageUpButton />
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import TheFooter from '@/components/TheFooter.vue';
import MallHeader from '@/components/mall/MallHeader.vue';
import MallNav from '@/components/mall/MallNav.vue';
import api from '@/api';
import PageUpButton from '@/components/PageUpButton.vue';
import { updateLastSeen } from '@/helpers';
export default {
  name: 'MallLayout',
  components: {
    TopHeader,
    MallHeader,
    TheFooter,
    MallNav,
    PageUpButton,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    getCurrentLocationId() {
      const savedLocation = JSON.parse(localStorage.getItem('selectedLocation')) || 1;

      if (typeof savedLocation === 'object') {
        return savedLocation?.id;
      }

      return savedLocation;
    },

    async getMallCategories() {
      try {
        const response = await api.get('mall/categories/', {
          params: {
            location: this.getCurrentLocationId(),
          },
        });

        this.$store.setState('mallCategories', response.data);
      } catch (e) {
        console.log(e);
      }
    },
  },

  watch: {
    '$i18n.locale': {
      async handler() {
        await this.getMallCategories();
      },
    },
  },

  computed: {},

  mounted() {
    updateLastSeen('mall_products');
  },

  async created() {
    await this.getMallCategories();
  },
};
</script>
